import React from "react";
import { useEffect, useRef, useState } from "react";
import "./multiselect.css";

const MultiSelect = ({ options, selectedValues, onSelect, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handler for when an option is clicked
  const handleOptionClick = (option) => {
    const isSelected = selectedValues.some(
      (selected) => selected.value === option.value
    );

    if (isSelected) {
      onSelect(selectedValues.filter((val) => val.value !== option.value));
    } else {
      onSelect([...selectedValues, option]);
    }
  };

  // Handler for removing a selected tag
  const handleRemoveTag = (optionToRemove, e) => {
    e.stopPropagation(); // Prevent dropdown from opening/closing
    onSelect(
      selectedValues
        .filter((val) => val != null)
        .filter((val) => val.value !== optionToRemove.value)
    );
  };

  return (
    <div className="multiselect-wrapper" ref={dropdownRef}>
      {/* Input display area */}
      <div
        className="multiselect-input-area"
        onClick={() => setIsOpen(!isOpen)} // Toggle dropdown on click
      >
        {selectedValues.length > 0 ? (
          <div className="multiselect-tags-container">
            {selectedValues.map((option) => (
              <span key={option.value} className="multiselect-tag">
                {option.label}
                <button
                  type="button"
                  onClick={(e) => handleRemoveTag(option, e)}
                  className="multiselect-tag-remove-btn"
                  aria-label={`Remove ${option.label}`}
                >
                  <svg
                    className="multiselect-icon-sm"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </span>
            ))}
          </div>
        ) : (
          <span className="multiselect-placeholder">{placeholder}</span>
        )}

        {/* Dropdown arrow icon */}
        <div
          className={`multiselect-arrow ${
            isOpen ? "multiselect-arrow-open" : ""
          }`}
        >
          <svg
            className="multiselect-icon-md"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M19 9l-7 7-7-7"
            ></path>
          </svg>
        </div>
      </div>

      {/* Dropdown options list */}
      {isOpen && (
        <div className="multiselect-options-list custom-scrollbar">
          {options.map((option) => {
            const isSelected = selectedValues.some(
              (selected) => selected.value === option.value
            );
            return (
              <div
                key={option.value}
                className={`multiselect-option-item ${
                  isSelected ? "multiselect-option-selected" : ""
                }`}
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
                {isSelected && (
                  <svg
                    className="multiselect-icon-md multiselect-checkmark"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelect;